<template>
      <div id="total-health">
            <section class="total-hero-photo animate__animated animate__fadeIn">
                  <img src="~@/assets/img/total-health-total-you-hero-2026.jpg" alt="Couple sitting together at home" />
                  <BackButton link="/therapist" />
                  <div class="total-hero-title">
                        <h1>Total Health,<br />Total You</h1>
                  </div>
            </section>
            <section class="total-content">
                  <div class="grid-container max">
                        <div class="total-grid">
                              <div class="total-left">
                                    <p class="total-heading">Have someone by your side to help you achieve your health goals.</p>
                                    <p class="total-desc">Total Health, Total You offers a holistic clinical management approach to address all your healthcare needs.</p>
                                    <p class="total-team-label">A team that delivers</p>
                                    <div class="total-team-grid">
                                          <div class="total-team-item">
                                                <img src="~@/assets/img/id-badge-icon.svg" alt="" />
                                                <span>Registered<br />nurses</span>
                                          </div>
                                          <div class="total-team-item">
                                                <img src="~@/assets/img/life-icon.svg" alt="" />
                                                <span>Social<br />workers</span>
                                          </div>
                                          <div class="total-team-item">
                                                <img src="~@/assets/img/sprout-icon.svg" alt="" />
                                                <span>Exercise<br />physiologists</span>
                                          </div>
                                          <div class="total-team-item">
                                                <img src="~@/assets/img/pill-icon.svg" alt="" />
                                                <span>Pharmacists</span>
                                          </div>
                                          <div class="total-team-item">
                                                <img src="~@/assets/img/health-coaches-icon.svg" alt="" />
                                                <span>Health<br />coaches</span>
                                          </div>
                                          <div class="total-team-item">
                                                <img src="~@/assets/img/apple-icon.svg" alt="" />
                                                <span>Registered<br />dietitians</span>
                                          </div>
                                          <div class="total-team-item">
                                                <img src="~@/assets/img/tree-icon.svg" alt="" />
                                                <span>Respiratory<br />therapists</span>
                                          </div>
                                    </div>
                              </div>
                              <div class="total-right">
                                    <div class="total-waiver-box">
                                          <h5>Co-Pay/Co-Insurance Waiver Program</h5>
                                          <p>Eligible SHBP members can receive certain prescription drugs for asthma, diabetes, and coronary artery disease (CAD) at no additional cost.</p>
                                          <hr />
                                          <p class="total-waiver-phone">To learn more, call <strong>866-901-0746</strong>, available from 8 a.m. to 6 p.m. ET, Monday through Friday.</p>
                                    </div>
                              </div>
                        </div>
                  </div>
            </section>
            <div class="total-btn-wrap">
                  <router-link to="/rewards" class="total-btn"><span>Next</span></router-link>
            </div>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPTotalHealth",
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#total-health {
      .total-hero-photo {
            position: relative;
            margin-top: 68px;
            height: 560px;
            overflow: hidden;

            img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
            }

            .back-btn {
                  position: absolute;
                  top: 40px;
                  left: 86px;
                  border-color: #ffffff;

                  &::before {
                        background-image: none;
                        background-color: #ffffff;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .total-hero-title {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  padding: 0 24px 0 86px;

                  h1 {
                        color: #ffffff;
                        font-size: clamp(2.75rem, 5vw, 4.5rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 0;
                  }
            }
      }

      .total-content {
            background-color: #ffffff;
            padding: 64px 0 160px 0;

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .total-grid {
                  display: flex;
                  flex-wrap: nowrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 48px;
            }

            .total-left {
                  flex: 2 1 560px;
                  max-width: 760px;

                  .total-heading {
                        color: #012E58;
                        font-size: 1.25rem;
                        font-weight: 600;
                        line-height: 1.4;
                        margin-bottom: 8px;
                  }

                  .total-desc {
                        color: #3F3A4E;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 32px;
                  }

                  .total-team-label {
                        color: #1355E9;
                        font-weight: 700;
                        font-size: 1.125rem;
                        margin-bottom: 24px;
                  }
            }

            .total-team-grid {
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  gap: 32px 24px;
            }

            .total-team-item {
                  display: flex;
                  align-items: center;
                  gap: 12px;

                  img {
                        display: block;
                        flex-shrink: 0;
                        width: 40px;
                        height: 40px;
                        object-fit: contain;
                  }

                  span {
                        color: #12130f;
                        font-size: 0.9375rem;
                        font-weight: 400;
                        line-height: 1.3;
                  }
            }

            .total-right {
                  flex: 1 1 400px;
                  max-width: 500px;
                  margin-top: -64px;
            }

            .total-waiver-box {
                  background-color: #1355E9;
                  padding: 96px 40px;

                  h5 {
                        color: #ffffff;
                        font-weight: 700;
                        font-size: 1.1875rem;
                        margin-bottom: 12px;
                  }

                  p {
                        color: rgba(255, 255, 255, 0.9);
                        font-size: 0.9375rem;
                        line-height: 1.6;
                        margin-bottom: 0;
                  }

                  hr {
                        border: none;
                        border-top: solid 1px rgba(255, 255, 255, 0.3);
                        margin: 24px 0;
                  }

                  .total-waiver-phone {
                        strong {
                              font-weight: 700;
                        }
                  }
            }
      }

      .total-btn-wrap {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            background-color: #ffffff;
            box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
            padding: 20px 0;
            text-align: center;
      }

      .total-btn {
            display: block;
            background-color: #1355E9;
            color: #ffffff !important;
            font-weight: 700;
            text-transform: uppercase;
            font-size: 1rem;
            padding: 18px 0;
            width: 100%;
            max-width: 330px;
            text-align: center;
            border-radius: 30px;
            border: none;
            cursor: pointer;
            margin: 0 auto;

            &:hover {
                  background-color: #44B8F3;
            }
      }

      @media only screen and (max-width: 959px) {
            .total-hero-photo {
                  height: 380px;

                  .back-btn {
                        top: 24px;
                        left: 2rem;
                  }

                  .total-hero-title {
                        padding: 0 24px;

                        h1 {
                              font-size: clamp(2.25rem, 9vw, 3.25rem) !important;
                        }
                  }
            }

            .total-content {
                  padding: 40px 24px 180px 24px;

                  .total-grid {
                        flex-direction: column;
                        gap: 32px;
                  }

                  .total-left {
                        max-width: 100%;
                  }

                  .total-right {
                        max-width: 100%;
                        width: 100%;
                        margin-top: 0;
                  }

                  .total-team-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 24px 16px;
                  }

                  .total-waiver-box {
                        padding: 32px 24px;
                  }
            }
      }
}
</style>
